enum NotificationPositionEnum {
    br = "bottom-right",
    bl = "bottom-left",
    bc = "bottom-center",
    tr = "top-right",
    tl = "top-left",
    tc = "top-center",
}

export default NotificationPositionEnum;
